import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import OurWorkForm from "./OurWorkForm";

export default function EditOurWork({ name }) {
    return (
        <CustomCard title={name}>
            <OurWorkForm type="EDIT" />
        </CustomCard>
    );
}
